import { launchStrategy } from "../../basic/path";
import RequestModel from "../../basic/requestConfig";

export default {
  export4Excel(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.export4Excel,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getSupplier(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getSupplier,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getEmail(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getEmail,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getStrategyList(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getStrategyList,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getActionPushDetailById(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getActionPushDetailById,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getStrategyDetail(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getStrategyDetail,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  saveStrategy(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.saveStrategy,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  changeOrderEvent(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.changeOrderApi,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getStrategyTypeTree(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getStrategyTypeTree,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getStrategyParentType(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getStrategyParentType,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getStrategyType(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getStrategyType,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  addStrategyType(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.addStrategyType,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getStrategyConfigList(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getStrategyConfigList,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getGlobalConfig(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getGlobalConfig,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  delStrategyById(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.delStrategyById,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  deleteStrategyById(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.deleteStrategyById,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  delStrategyActionById(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.delStrategyActionById,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  saveStrategyConfig(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.saveStrategyConfig,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  saveStrategyAction(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.saveStrategyAction,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  saveGlobalStrategyConfig(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.saveGlobalStrategyConfig,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  searchStrategyJoinConfigList(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.searchStrategyJoinConfigList,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  // checkModifyDeadline(vue, query) {
  //     return new Promise((resolve, reject) => {
  //         let requestModel = new RequestModel({
  //             method: 'get',
  //             url: launchStrategy.checkModifyDeadline,
  //             data: query.data ? query.data : {},
  //             params: query.params ? query.params : {}
  //         }),
  //         request = requestModel.defaultConfig();
  //         vue.axios(request).then(function (result) {
  //             resolve(result);
  //         })
  //     });
  // },
  // checkPriorityModifyStatus(vue, query) {
  //     return new Promise((resolve, reject) => {
  //         let requestModel = new RequestModel({
  //             method: 'get',
  //             url: launchStrategy.checkPriorityModifyStatus,
  //             data: query.data ? query.data : {},
  //             params: query.params ? query.params : {}
  //         }),
  //         request = requestModel.defaultConfig();
  //         vue.axios(request).then(function (result) {
  //             resolve(result);
  //         })
  //     });
  // },
  saveStrategyOrderList(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.saveStrategyOrderList,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  recoveryStrategy(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.recoveryStrategy,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  delStrategyBack(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.delStrategyBack,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  rankStrategyPriority(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.rankStrategyPriority,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getDistGroupList(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getDistGroupList,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getStrategyAction(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: launchStrategy.getStrategyAction,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  createStrategy(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.createStrategy,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  updStrategy(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.updStrategy,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  delStrategy(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: launchStrategy.delStrategyById,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
};
